// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__U0znY","container":"style_container__Y6m5K","orders":"style_orders__2pSRM","stats":"style_stats__3t08I"};